var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeServicesIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 270 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3444_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.069 109.768C204.932 110.281 206.777 110.757 208.183 111.086C210.137 111.562 212.475 111.855 214.01 113.339C215.818 115.097 215.361 117.753 212.914 118.613C211.434 119.126 209.772 118.686 208.256 118.32C205.48 117.624 202.704 117.038 199.964 116.214",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.571 118.723C210.777 119.492 211.434 121.488 210.649 122.77C209.571 124.528 206.685 123.997 205.042 123.668C202.539 123.173 200.165 122.129 197.718 121.433",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.599 127.551C197.553 127.918 199.471 128.522 201.425 128.888C202.411 129.071 203.416 129.181 204.384 129.071C206.393 128.815 208.457 125.445 206.393 123.889",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.932 131.928C200.292 132.295 202.758 131.672 202.868 129.09",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.019 131.066C183.654 132.403 184.238 133.704 185.571 134.07C186.777 134.4 188.019 133.795 188.512 132.66C188.567 132.55 188.603 132.422 188.64 132.294",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8 131.837L184.019 131.068L184.603 128.999C184.969 127.661 186.302 126.911 187.58 127.259C188.859 127.607 189.626 128.944 189.279 130.226L188.658 132.332",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.868 131.305L179.507 129.034L179.581 128.796L180.238 126.47C180.64 125.152 181.973 124.419 183.252 124.785C184.53 125.17 185.261 126.507 184.877 127.789L183.599 132.459L183.27 133.668",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.795 127.953L175.416 125.939C175.434 125.865 175.453 125.81 175.471 125.737C175.909 124.602 177.17 123.979 178.357 124.327C179.617 124.693 180.329 126.012 179.946 127.275L178.868 131.286",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.795 127.955C175.051 126.801 174.357 125.611 173.188 125.299C172.001 124.97 170.759 125.684 170.43 126.874L170.284 127.405",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.581 128.797L179.453 129.273L178.375 133.283C177.973 134.602 176.64 135.353 175.361 134.968C174.083 134.584 173.352 133.247 173.736 131.965L175.489 125.757V125.738",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8 131.836L183.782 131.89L183.617 132.44L183.197 133.795C182.832 135.059 181.517 135.773 180.256 135.389C178.996 135.022 178.284 133.704 178.668 132.44L179.453 129.253L179.508 129.015L179.946 127.275",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.832 127.882L174.795 127.955V127.973L174.777 128.01L173.864 130.501C173.535 131.673 172.384 132.332 171.252 132.039C170.138 131.728 169.462 130.574 169.772 129.438L169.973 128.669L170.302 127.424",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87817 121.435C12.8781 138.449 31.1246 142.862 45.4075 140.023C63.581 136.416 75.3437 121.233 85.9553 107.278C92.6404 98.5056 97.1336 88.9825 107.051 83.4701C114.905 79.1114 126.521 78.104 133.827 84.166C142.412 91.29 139.69 104.146 130.85 108.707C120.549 114.018 105.681 108.304 98.9234 99.8793C97.6997 98.3591 96.6403 96.6928 95.8 94.9346C90.7955 84.5139 94.9783 71.8406 103.234 64.3869C113.371 55.23 129.024 51.8418 141.663 56.7501C158.923 63.4347 162.046 81.6387 161.225 98.3775C161.188 99.2201 161.133 100.044 161.078 100.887C160.804 105.264 160.421 112.315 165.955 113.541C171.398 114.75 176.11 110.044 180.22 107.241C185.535 103.615 191.964 101.216 198.448 101.674",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.585 47.5374C145.467 47.5374 155.909 37.0669 155.909 24.1506C155.909 11.2343 145.467 0.763672 132.585 0.763672C119.703 0.763672 109.261 11.2343 109.261 24.1506C109.261 37.0669 119.703 47.5374 132.585 47.5374Z",
    stroke: "#EF6D58",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.128 3.78516H236.055V43.966H276.128V3.78516Z",
    stroke: "#EF6D58",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.996 61.2529H173.736L196.366 21.0723L218.996 61.2529Z",
    stroke: "#EF6D58",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.224 131.984C194.448 131.82 191.672 131.673 188.896 131.545",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.293 110.062C202.996 109.805 201.827 109.274 200.457 109.622C199.014 109.97 197.699 110.685 196.311 111.179C194.521 111.82 192.621 111.783 190.886 111.014C190.028 110.63 188.914 109.952 188.53 109.055C187.927 107.681 189.699 107.168 190.558 106.674C192.585 105.52 194.631 104.385 196.567 103.066C198.138 102.004 199.58 100.63 201.407 100.026C205.936 98.5057 210.831 100.191 215.398 100.612C219.836 101.015 224.512 100.667 228.402 98.286C242.429 89.6418 234.704 69.2218 243.708 57.446C249.114 50.3583 261.005 48.7835 268.219 53.8564C276.694 59.8268 275.817 71.0899 275.817 80.3567C275.817 89.0924 276.895 100.703 268.146 105.74C256.621 112.37 243.617 103.304 236.694 94.2019C231.215 87.0046 225.991 79.8439 217.973 75.2472C210.923 71.1997 202.85 69.0936 194.722 69.0936C169.151 69.0936 148.439 89.4953 148.439 114.659C148.439 132.68 159.854 149.62 176.457 156.47C185.261 160.095 195.051 160.81 204.402 159.253C219.398 156.744 237.096 147.99 241.735 132.277C244.238 123.779 243.05 109.219 233.26 105.593C229.534 104.22 224.804 105.154 222.009 108.011C221.462 108.579 220.987 109.219 220.603 109.934C217.681 115.318 220.037 121.801 223.051 126.544C225.991 131.196 230.101 135.079 234.886 137.753C239.818 140.518 245.425 141.965 251.069 141.965C269.388 141.965 284.237 127.075 284.237 108.707C284.237 97.6268 278.265 85.2464 267.215 81.3638C264.676 80.4665 261.973 80.1552 259.306 80.4482",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6633 152.55C79.8917 147.385 83.8551 142.953 89.2065 139.858C101.371 132.826 116.038 132.972 129.626 132.203C143.106 130.921 156.476 130.61 169.9 130.866",
    stroke: "#093649",
    strokeWidth: 2.36023,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3444_1032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeServicesIllustration);
export default __webpack_public_path__ + "static/media/home_services_illustration.9186225008f2f721b985c122a29e5bbb.svg";
export { ForwardRef as ReactComponent };